"use strict";

var _createForOfIteratorHelper = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;
var _objectSpread = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TStyles = require("../styles/TStyles");
var _markersPrototype = _interopRequireDefault(require("./markersPrototype"));
var _tnodeSnapshot = _interopRequireDefault(require("./tnodeSnapshot"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function updateNodeIndexes(node, i) {
  node.nodeIndex = i;
}
var emptyAttrs = Object.freeze({});
var emptyClasses = Object.freeze([]);
function findNativeRole(ariaRole) {
  if (ariaRole === 'img') {
    return 'image';
  }
  if (ariaRole === 'heading') {
    return 'header';
  }
  if (ariaRole === 'dialog') {
    return 'alert';
  }
  if (ariaRole === 'presentation') {
    return 'none';
  }
  if (ariaRole === 'button' || ariaRole === 'switch' || ariaRole === 'checkbox' || ariaRole === 'radio' || ariaRole === 'radiogroup' || ariaRole === 'link' || ariaRole === 'search') {
    return ariaRole;
  }
}
function setMarkersFromAttributes(targetMarkers, _parentMarkers, _ref) {
  var attributes = _ref.attributes;
  if ('dir' in attributes) {
    targetMarkers.direction = attributes.dir;
  }
  if ('lang' in attributes) {
    targetMarkers.lang = attributes.lang;
  }
}
function transformPropsDefinitionsToSwitch(definition) {
  if (!definition) {
    return null;
  }
  return {
    text: _objectSpread(_objectSpread({}, definition.native), definition.text),
    view: _objectSpread(_objectSpread({}, definition.native), definition.view)
  };
}
function mergeSwitches(prev, next) {
  if (!prev) {
    return next;
  }
  if (!next) {
    return prev;
  }
  return {
    text: _objectSpread(_objectSpread({}, prev.text), next.text),
    view: _objectSpread(_objectSpread({}, prev.view), next.view)
  };
}
var prototype = {
  children: Object.freeze([]),
  init: Object.freeze({}),
  classes: Object.freeze([]),
  styles: Object.freeze(_TStyles.TStyles.empty()),
  markers: _markersPrototype.default,
  __nodeIndex: null,
  __trimmedLeft: false,
  __trimmedRight: false,
  __nativeProps: false,
  __nativeStyles: false,
  __webStyles: false,
  __generateNativePropsFromTNode: function __generateNativePropsFromTNode() {
    var ret = null;
    if (this.styles.webTextFlow.userSelect) {
      ret = mergeSwitches(ret, {
        text: {
          selectable: this.styles.webTextFlow.userSelect !== 'none'
        }
      });
    }
    if (this.attributes['aria-label']) {
      var accessibilityProps = {
        accessibilityLabel: this.attributes['aria-label']
      };
      ret = mergeSwitches(ret, {
        view: accessibilityProps,
        text: accessibilityProps
      });
    }
    if (this.attributes.role) {
      var role = this.attributes.role;
      var accessibilityRole = findNativeRole(role);
      if (accessibilityRole) {
        var _accessibilityProps = {
          accessibilityRole: accessibilityRole
        };
        ret = mergeSwitches(ret, {
          view: _accessibilityProps,
          text: _accessibilityProps
        });
      }
    }
    return ret;
  },
  __generateDynamicNativePropsFromModel: function __generateDynamicNativePropsFromModel(autoGeneratedProps) {
    var elm = this.elementModel;
    if (!elm || !elm.getReactNativeProps) {
      return null;
    }
    return transformPropsDefinitionsToSwitch(elm.getReactNativeProps(this, autoGeneratedProps, this.domNode) || null);
  },
  get attributes() {
    var _this$domNode;
    return ((_this$domNode = this.domNode) === null || _this$domNode === void 0 ? void 0 : _this$domNode.attribs) || emptyAttrs;
  },
  get hasWhiteSpaceCollapsingEnabled() {
    return typeof this.styles.webTextFlow.whiteSpace === 'string' ? this.styles.webTextFlow.whiteSpace === 'normal' : true;
  },
  get contentModel() {
    var _this$elementModel;
    return ((_this$elementModel = this.elementModel) === null || _this$elementModel === void 0 ? void 0 : _this$elementModel.contentModel) || null;
  },
  get parentStyles() {
    var _this$parent;
    return this.init.parentStyles || ((_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.styles) || null;
  },
  get id() {
    return this.attributes.id || null;
  },
  get domNode() {
    return this.init.domNode || null;
  },
  get elementModel() {
    return this.init.elementModel;
  },
  get tagName() {
    var _this$init$domNode;
    return ((_this$init$domNode = this.init.domNode) === null || _this$init$domNode === void 0 ? void 0 : _this$init$domNode.name) || null;
  },
  get parent() {
    return this.init.parent || null;
  },
  get nodeIndex() {
    if (this.__nodeIndex === null) {
      this.__nodeIndex = this.init.nodeIndex || 0;
    }
    return this.__nodeIndex;
  },
  get isUnregistered() {
    return this.init.isUnregistered || false;
  },
  set nodeIndex(nodeIndex) {
    this.__nodeIndex = nodeIndex;
  },
  bindChildren: function bindChildren(children) {
    var shouldUpdateNodeIndexes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    //@ts-ignore
    this.children = children;
    if (shouldUpdateNodeIndexes) {
      children.forEach(updateNodeIndexes);
    }
  },
  cloneInitParams: function cloneInitParams(partial) {
    return Object.assign({}, this.init, partial);
  },
  isCollapsibleLeft: function isCollapsibleLeft() {
    if (this.children.length) {
      return this.hasWhiteSpaceCollapsingEnabled && this.children[0].isCollapsibleLeft();
    }
    return false;
  },
  isCollapsibleRight: function isCollapsibleRight() {
    if (this.children.length) {
      return this.hasWhiteSpaceCollapsingEnabled && this.children[this.children.length - 1].isCollapsibleRight();
    }
    return false;
  },
  isEmpty: function isEmpty() {
    return false;
  },
  trimLeft: function trimLeft() {
    if (!this.__trimmedLeft && this.children.length) {
      var firstChild = this.children[0];
      firstChild.trimLeft();
      if (firstChild.isEmpty()) {
        //@ts-ignore
        this.children.splice(0, 1);
      }
      this.__trimmedLeft = true;
    }
  },
  trimRight: function trimRight() {
    if (!this.__trimmedRight && this.children.length) {
      var lastChild = this.children[this.children.length - 1];
      lastChild.trimRight();
      if (lastChild.isEmpty()) {
        //@ts-ignore
        this.children.splice(-1, 1);
      }
      this.__trimmedRight = true;
    }
  },
  matchContentModel: function matchContentModel() {
    return false;
  },
  spliceChildren: function spliceChildren(indexesToSplice) {
    var offset = 0;
    var _iterator = _createForOfIteratorHelper(indexesToSplice),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var i = _step.value;
        //@ts-ignore
        this.children.splice(i - offset, 1);
        offset += 1;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  collapse: function collapse() {
    this.collapseChildren();
    this.bindChildren(this.children, true);
  },
  getNativeStyles: function getNativeStyles() {
    if (this.__nativeStyles === false) {
      this.__nativeStyles = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.styles.nativeBlockFlow), this.styles.nativeBlockRet), this.styles.nativeTextFlow), this.styles.nativeTextRet);
    }
    return this.__nativeStyles;
  },
  getWebStyles: function getWebStyles() {
    if (this.__webStyles === false) {
      this.__webStyles = _objectSpread(_objectSpread({}, this.styles.webTextFlow), this.styles.webBlockRet);
    }
    return this.__webStyles;
  },
  collapseChildren: function collapseChildren() {
    return;
  },
  snapshot: function snapshot() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$withStyles = options.withStyles,
      withStyles = _options$withStyles === void 0 ? false : _options$withStyles,
      _options$withNodeInde = options.withNodeIndex,
      withNodeIndex = _options$withNodeInde === void 0 ? false : _options$withNodeInde;
    return (0, _tnodeSnapshot.default)(this, {
      withStyles: withStyles,
      withNodeIndex: withNodeIndex
    });
  },
  hasClass: function hasClass(className) {
    return this.classes.indexOf(className) > -1;
  },
  toString: function toString() {
    return this.snapshot();
  },
  setMarkers: function setMarkers(targetMarkers, parentMarkers) {
    var _this$elementModel2, _this$init$context$se, _this$init$context;
    if ((_this$elementModel2 = this.elementModel) !== null && _this$elementModel2 !== void 0 && _this$elementModel2.setMarkersForTNode) {
      this.elementModel.setMarkersForTNode(targetMarkers, parentMarkers, this);
    }
    setMarkersFromAttributes(targetMarkers, parentMarkers, this);
    (_this$init$context$se = (_this$init$context = this.init.context).setMarkersForTNode) === null || _this$init$context$se === void 0 ? void 0 : _this$init$context$se.call(_this$init$context, targetMarkers, parentMarkers, this);
  },
  getReactNativeProps: function getReactNativeProps() {
    if (this.__nativeProps === false) {
      var _this$elementModel3;
      var staticFromModel = transformPropsDefinitionsToSwitch((_this$elementModel3 = this.elementModel) === null || _this$elementModel3 === void 0 ? void 0 : _this$elementModel3.reactNativeProps);
      var dynamicFromAttrs = this.__generateNativePropsFromTNode();
      var autoGeneratedProps = mergeSwitches(staticFromModel, dynamicFromAttrs);
      var dynamicFromModel = this.__generateDynamicNativePropsFromModel(autoGeneratedProps);
      this.__nativeProps = mergeSwitches(autoGeneratedProps, dynamicFromModel);
    }
    return this.__nativeProps;
  },
  initialize: function initialize(init) {
    var _this$attributes$clas;
    this.init = init;
    this.classes = ((_this$attributes$clas = this.attributes.class) === null || _this$attributes$clas === void 0 ? void 0 : _this$attributes$clas.split(/\s+/)) || emptyClasses;
    var parentMarkers = init.parent ? init.parent.markers : _markersPrototype.default.extend();
    this.markers = parentMarkers.extend();
    this.setMarkers(this.markers, parentMarkers, this); // Avoid very long prototype chains by assigning parent to current
    // when current has no own properties

    if (Object.keys(this.markers).length === 0) {
      this.markers = parentMarkers;
    }
    this.styles = init.styles || init.context.stylesMerger.buildStyles(this.attributes.style, this.parentStyles || null, this);
  }
};
var TNodeCtor = function TNode(type, displayName, extraAccessors) {
  this.type = type;
  this.displayName = displayName;
  extraAccessors && Object.defineProperties(this, extraAccessors);
};
TNodeCtor.prototype = prototype;
var _default = TNodeCtor;
exports.default = _default;